import { LocaleD } from "db"
import * as t from "io-ts"

export const LocalizedSearchTermDC = t.type({
  locale: t.union([t.literal(LocaleD.en_ca), t.literal(LocaleD.fr_ca)]),
  q: t.string,
})

export type LocalizedSearchTermD = t.TypeOf<typeof LocalizedSearchTermDC>
